module.exports = __webpack_public_path__ + "static/media/ios_badge_ch.41b04c7d.svg";